import React from 'react';

import { HomeCardFront } from '../home-card-front';

export interface HomeBusinessCardFrontProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeBusinessCardFront = React.memo<HomeBusinessCardFrontProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardFront
      icon={'gear'}
      iconColor={'secondary'}
      title={'Turn operations into an efficient business enabler'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
